import { render, staticRenderFns } from "./clipper-range.vue?vue&type=template&id=4c49afa9&scoped=true&"
import script from "./clipper-range.vue?vue&type=script&lang=js&"
export * from "./clipper-range.vue?vue&type=script&lang=js&"
import style0 from "./clipper-range.vue?vue&type=style&index=0&id=4c49afa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c49afa9",
  null
  
)

export default component.exports